<template>
  <div class="profile-settings text-center">
    <TopMenu
      :title="$t('PROFILE.JOBSTATUS.PAGE_LABEL')"
      :back-to="$route.name === 'information-job-status'? '/dashboard': '/dashboard/profile'"
      dark-background
    />
    <div class="container-fluid content">
      <form
        class="form-profile-settings m-2"
        @submit.prevent>
        <div class="row-item-transparent-with-border mt-3 mb-4 text-left">
          <h3>{{ $t('PROFILE.JOBSTATUS.HEADER') }}</h3>
        </div>
        <a
          :href="employLink"
          class="btn btn-lg btn-secondary btn-block"
          target="_blank">{{ $t("PROFILE.JOBSTATUS.FIND_JOB") }}</a>
        <a
          :href="foundEmployLink"
          class="btn btn-lg btn-secondary btn-block"
          target="_blank">{{ $t("PROFILE.JOBSTATUS.FOUND_JOB") }}</a>
        <ActionButton
          v-if="!displayNoStatusNote"
          class="btn btn-lg btn-primary btn-block mt-3 mb-3"
          @click="showConfirmStatusChanged = true"
        >{{ $t("PROFILE.JOBSTATUS.SAVE_BUTTON") }}</ActionButton>
        <div v-if="false">{{ $t("PROFILE.JOBSTATUS.NOEMPLOYMENTSTATUS") }}</div>
        <ConfirmModal
          v-if="showConfirmStatusChanged"
          show-modal
          size="md"
          @cancel="showConfirmStatusChanged = false"
          @confirm="save"
        >{{ $t("PROFILE.JOBSTATUS.JOBSTATUS_CHANGED") }}</ConfirmModal>
      </form>
    </div>
    <BottomMenu/>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { mapState } from 'vuex';
import TopMenu from '@/components/Menu/TopMenu';
import BottomMenu from '@/components/Menu/BottomMenu';
import ActionButton from '@/components/Actions/ActionButton';
import FormSelect from '@/components/Forms/FormSelect';
import ConfirmModal from '@/components/Modal/ConfirmModal';
import config from '@/config';

export default {
  name: 'ProfileJobStatus',
  components: {
    ActionButton,
    TopMenu,
    BottomMenu,
    FormSelect,
    ConfirmModal,
  },
  data() {
    return {
      localEmployment: {
        hasJob: true,
      },
      showConfirmStatusChanged: false,
      showNoStatus: false,
    };
  },
  computed: {
    employLink() {
      return config.EMPLOYMENT_LINK;
    },
    foundEmployLink() {
      return config.FOUNDEMPLOYMENT_LINK;
    },
    displayNoStatusNote() {
      return this.showNoStatus
      || this.localEmployment.hasJob === undefined
      || this.localEmployment.hasJob === null;
    },
  },
  watch: {
    selectedEmployment: {
      handler(newVal) {
        if (newVal) {
          this.localEmployment = cloneDeep(newVal);
        } else {
          this.localEmployment = { hasJob: true };
        }
      },
      immediate: true,
    },
  },
  created() {
    this.$store.dispatch('member/currentMemberEmployment').then(
      () => {
        if (
          !this.selectedEmployment
          || this.localEmployment.hasJob === undefined
        ) {
          this.showNoStatus = true;
        }
      },
      () => {
        this.showNoStatus = true;
      },
    );
  },
  methods: {
    save() {
      this.showConfirmStatusChanged = false;
      this.$store
        .dispatch('member/saveEmployment', this.localEmployment)
        .then(() => {
          this.$store.commit('alerts/setAlert', {
            msg: 'PROFILE.JOBSTATUS.CONFIRMATION_MESSAGE',
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
div {
  &.profile-settings {
    height: 100%;
  }
  &.content {
    padding-top: $top-menu-height;
    padding-bottom: $bottom-menu-height;
    background-color: $base;
    min-height: 100%;
  }
}
</style>
